module.exports = __webpack_public_path__ + "img/Frame 1063three.270c0bd8.png";